/* sb-dc-addprogress.js - show what "Building the print file" is doing, and
   tell the customer when leaving the tab has stopped it.
   2026-09-22 (v6 - bigger card, and the bar glides instead of jumping; see
   MOVEMENT).

   WHY (measured 2026-09-18, live data + the browser)

   dc_events, last 14 days:
       cart_add_try   543
       cart_add_ok    353        <- 35% of approvals never reach the cart
       cart_add_hang   80        <- 25s / 60s marks, many at stage "uploaded"
   Individual cart_add_done rows on 96x48 boards: 10-20s normally, but also
   87s, 482s and 3564s (59 minutes).

   A hidden tab gets no animation frames, and the print render rides on them,
   so the whole job freezes until the customer comes back. That is the 482s
   and the 3564s: not slow work, stopped work.

   WHAT THIS DOES
   A card centred on screen over a dimmed, blurred backdrop: the stage, a
   percentage, the elapsed time, and - the point of the exercise - a plain
   PAUSED message (in the card and in the tab title) when leaving the tab has
   stopped the job. The backdrop hides the proof modal's own status line so
   only one message is read, and takes the clicks so a second Approve cannot
   land.

   The bar is honest about what it knows:
       0-40%    rendering - no progress signal exists inside the bundle, so
                this ramps on elapsed time and never pretends to be finished
       40-90%   uploading - REAL bytes sent, from sb-dc-upload.js's
                'sbdc:progress' events
       90-100%  finalise and cart

   MOVEMENT (2026-09-22)
   Those targets arrive in steps - with the pre-upload in place the upload
   phase reports 1 of 1 at once, so the bar went 20 -> 90 -> 92 -> 97 in a
   blink and looked like it was bouncing. The target (st.pct) and what is
   drawn (shown) are now separate: every animation frame the drawn value moves
   a fraction of the remaining distance toward the target, with a small floor
   so it never stalls just short. It never moves backwards. On success it runs
   up to 100% and holds for a moment before the card goes, so the finish is
   seen rather than cut off.

   Also here: one click only on Approve, a 30s "large banners can take up to a
   minute" note, and everything clears itself when the add finishes or the
   page leaves.

   MEASURING
   Every finished add writes one 'cart_speed' row to dc_events: ms, how, path,
   pre, proofSecs, waitMs, putMs, promoteMs, hashMs, mb, hidden, hiddenMs, w, h.
   keepalive is set because the bundle moves to /cart the moment the line lands.

   WHEN IT ENDS
   The approve button does not go through window.__dcAddToCart, so the cart
   itself is the signal: its line count is taken at start and checked once the
   upload side reports it is done. When it goes up, the job is finished.

   It does not touch the document, the print file, or the cart.

   Diagnostics: window.__dcAddProgress() */
(function () {
  'use strict';

  var LONG_MS = 30000;        // "this can take up to a minute" threshold
  var RENDER_CEIL = 40;       // % the render phase is allowed to reach
  var RENDER_TAU = 18000;     // how fast it approaches that ceiling

  var NAVY = '#072747', ORANGE = '#FD913E';

  var st = {
    running: false, t0: 0, phase: '', pct: 0, blocked: 0,
    hiddenMs: 0, hiddenSince: 0, wasHidden: false, done: null,
    cartAtStart: null, watching: false
  };
  window.__dcAddProgress = function () { return st; };

  var el = null, bar = null, head = null, sub = null, note = null, timer = null;
  var shown = 0, raf = 0;          // drawn value, eased toward st.pct
  var titleBefore = null;

  /* ---------- panel ----------------------------------------------------- */
  function build() {
    if (el) return;
    /* el is the full-screen backdrop; the card sits in its centre. */
    el = document.createElement('div');
    el.id = 'sbdc-addprogress';
    el.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:2147483000',
      'display:flex', 'align-items:center', 'justify-content:center',
      'background:rgba(15,23,42,.55)',
      '-webkit-backdrop-filter:blur(3px)', 'backdrop-filter:blur(3px)',
      'padding:16px', 'box-sizing:border-box'
    ].join(';');

    var card = document.createElement('div');
    card.style.cssText = [
      'width:min(680px,94vw)', 'box-sizing:border-box',
      'background:#fff', 'border-radius:18px',
      'box-shadow:0 24px 60px rgba(7,39,71,.40)', 'padding:34px 38px',
      'font-family:Arial,Helvetica,sans-serif', 'color:' + NAVY
    ].join(';');
    el.appendChild(card);

    head = document.createElement('div');
    head.style.cssText = 'font-size:22px;line-height:1.3;font-weight:700;margin-bottom:18px';

    var track = document.createElement('div');
    track.style.cssText = 'height:14px;background:#eef2f6;border-radius:99px;overflow:hidden';
    bar = document.createElement('div');
    bar.style.cssText = 'height:100%;width:0%;background:' + NAVY + ';border-radius:99px;transition:background .3s ease';
    track.appendChild(bar);

    sub = document.createElement('div');
    sub.style.cssText = 'font-size:16px;line-height:1.45;color:#5b6672;margin-top:14px';

    note = document.createElement('div');
    note.style.cssText = 'font-size:15px;line-height:1.45;color:#8a5a12;margin-top:10px;display:none';

    card.appendChild(head);
    card.appendChild(track);
    card.appendChild(sub);
    card.appendChild(note);
    document.body.appendChild(el);
  }

  function paint() {
    if (!el) return;
    var secs = Math.round((Date.now() - st.t0) / 1000);
    var hidden = document.visibilityState === 'hidden';

    if (hidden) {
      /* Nobody reads this while it is hidden; it is what they see on return. */
      head.textContent = 'PAUSED - you left this tab';
      bar.style.background = ORANGE;
      sub.textContent = 'Nothing is being made while you are away. Come back to this tab to finish your order.';
    } else if (st.wasHidden && (Date.now() - st.hiddenSince) < 6000) {
      head.textContent = 'Running again - please stay on this tab';
      bar.style.background = ORANGE;
      sub.textContent = 'It was paused while you were away. ' + label() + ' - ' + secs + 's elapsed.';
    } else {
      head.textContent = 'Building your print file - please stay on this tab';
      bar.style.background = NAVY;
      sub.textContent = label() + ' - ' + secs + 's elapsed. Switching tabs pauses it.';
    }

    note.style.display = (secs * 1000 > LONG_MS) ? 'block' : 'none';
    note.textContent = 'Large banners can take up to a minute. Stay on this tab and do not close this window - it stops if you leave.';
  }

  /* Each frame, close a share of the gap to the target: fast when far, gentle
     as it arrives, never backwards. The floor keeps it from crawling forever
     just short of the target. */
  function glide() {
    if (!el || el.style.display === 'none') { raf = 0; return; }
    var gap = st.pct - shown;
    if (gap > 0) {
      shown += Math.max(0.12, gap * 0.05);
      if (shown > st.pct) shown = st.pct;
    }
    bar.style.width = Math.max(2, Math.min(100, shown)) + '%';
    raf = requestAnimationFrame(glide);
  }

  function label() {
    if (st.phase === 'upload') return 'Uploading ' + Math.round(shown) + '%';
    if (st.phase === 'finalize') return 'Almost done';
    if (st.phase === 'cart') return 'Adding to your cart';
    return 'Preparing the artwork';
  }

  /* ---------- phases ---------------------------------------------------- */
  function tick() {
    if (!st.running) return;
    if (st.phase === 'render') {
      /* Asymptotic: gets slower as it goes and never reaches the ceiling, so
         it cannot claim to be done while the render is still going. */
      var age = Date.now() - st.t0 - st.hiddenMs;
      st.pct = RENDER_CEIL * (1 - Math.exp(-age / RENDER_TAU));
    }
    paint();
  }

  function start() {
    if (st.running) return;
    st.running = true;
    st.t0 = Date.now();
    st.phase = 'render';
    st.pct = 0;
    st.hiddenMs = 0;
    st.wasHidden = false;
    st.done = null;
    st.cartAtStart = null;
    st.watching = false;
    cartCount().then(function (n) { st.cartAtStart = n; });

    shown = 0;
    build();
    el.style.display = 'flex';
    if (!raf) raf = requestAnimationFrame(glide);
    titleBefore = document.title;
    clearInterval(timer);
    timer = setInterval(tick, 400);
    tick();
  }

  function finish(how) {
    if (!st.running) return;
    st.running = false;
    st.done = how;
    clearInterval(timer);
    if (titleBefore) document.title = titleBefore;
    try { logSpeed(how); } catch (e) {}

    /* On success let the bar run home and be seen at 100% before it goes. */
    if (how === 'ok' && el) {
      st.pct = 100;
      st.phase = 'cart';
      head.textContent = 'Added to your cart';
      sub.textContent = 'Taking you to your cart...';
      note.style.display = 'none';
      setTimeout(function () { if (el) el.style.display = 'none'; }, 900);
      return;
    }
    if (el) el.style.display = 'none';
  }

  function logSpeed(how) {
    var S = window.__dcSupabase;
    if (!S || !S.url || !S.anonKey) return;
    var u = window.__dcUploadStats || {};
    var pre = (typeof window.__dcPreUpload === 'function') ? window.__dcPreUpload() : {};
    var api = window.__dcApi || {};
    var spec = api.spec || {};
    var opened = pre.openedAt || 0;
    var meta = {
      ms: Date.now() - st.t0,
      how: how,
      path: String(window.__dcUploadPath || '').slice(0, 40),
      pre: !!u.usedPreUpload,
      proofSecs: opened ? Math.round((st.t0 - opened) / 100) / 10 : null,
      waitMs: u.waitMs || 0, putMs: u.putMs || 0, promoteMs: u.promoteMs || 0,
      hashMs: u.hashMs || 0, mb: u.mb || 0,
      hidden: !!st.wasHidden, hiddenMs: st.hiddenMs || 0,
      w: spec.widthIn || null, h: spec.heightIn || null
    };
    fetch(S.url + '/rest/v1/dc_events', {
      method: 'POST',
      keepalive: true,
      headers: {
        'content-type': 'application/json',
        apikey: S.anonKey,
        Authorization: 'Bearer ' + S.anonKey,
        Prefer: 'return=minimal'
      },
      body: JSON.stringify({ kind: 'cart_speed', meta: meta })
    }).catch(function () {});
  }

  /* ---- the cart is the only honest "it finished" signal ---------------- */
  function cartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c && typeof c.item_count === 'number' ? c.item_count : null; })
      .catch(function () { return null; });
  }

  function watchCart() {
    if (st.watching) return;
    st.watching = true;
    var tries = 0;
    var iv = setInterval(function () {
      if (!st.running) { clearInterval(iv); return; }
      if (++tries > 40) { clearInterval(iv); finish('timeout'); return; }   // 20s
      cartCount().then(function (n) {
        if (n == null) return;
        if (st.cartAtStart == null) { st.cartAtStart = n; return; }
        if (n > st.cartAtStart) { clearInterval(iv); finish('ok'); }
      });
    }, 500);
  }

  /* Upload progress from sb-dc-upload.js. */
  window.addEventListener('sbdc:progress', function (e) {
    if (!st.running) return;
    var d = (e && e.detail) || {};
    if (d.phase === 'upload' && d.total) {
      st.phase = 'upload';
      st.pct = 40 + Math.min(50, (d.loaded / d.total) * 50);
    } else if (d.phase === 'finalize') {
      st.phase = 'finalize';
      st.pct = Math.max(st.pct, 92);
    } else if (d.phase === 'cart') {
      st.phase = 'cart';
      st.pct = 97;
      watchCart();
    }
    paint();
  });

  /* ---------- the tab-away case ----------------------------------------- */
  document.addEventListener('visibilitychange', function () {
    if (!st.running) return;
    if (document.visibilityState === 'hidden') {
      st.wasHidden = true;
      st.hiddenSince = Date.now();
      /* The tab strip is the only surface a customer on another tab sees. */
      document.title = 'PAUSED - go back to finish your order';
    } else {
      if (st.hiddenSince) st.hiddenMs += Date.now() - st.hiddenSince;
      st.hiddenSince = Date.now();     // reused as "came back at"
      if (titleBefore) document.title = titleBefore;
    }
    paint();
  });

  /* ---------- hooks ------------------------------------------------------ */

  /* One click only. The approve button is inside the bundle's modal, so this
     listens in the capture phase and stops the second one before it lands. */
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest && ev.target.closest('button');
    if (!b) return;
    if (!/approve and add to cart/i.test(b.textContent || '')) return;
    if (st.running) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      st.blocked++;
      paint();
      return;
    }
    start();
  }, true);

  /* Also wrap the function itself, for the paths that do not go through the
     button, and to know when the job actually ends. */
  var tries = 0;
  var hook = setInterval(function () {
    var f = window.__dcAddToCart;
    if (typeof f !== 'function') { if (++tries > 200) clearInterval(hook); return; }
    if (f.__prog) { clearInterval(hook); return; }
    var w = function () {
      start();
      var r;
      try { r = f.apply(this, arguments); }
      catch (e) { finish('error'); throw e; }
      return Promise.resolve(r).then(function (v) {
        finish(v ? 'ok' : 'false');
        return v;
      }, function (e) {
        finish('error');
        throw e;
      });
    };
    w.__prog = true;
    window.__dcAddToCart = w;
    clearInterval(hook);
  }, 200);

  window.addEventListener('pagehide', function () { finish('leaving'); });
})();
